(function () {
  $(document).ready(function () {
    if ($('body').hasClass('SitemapPage-top-level')) {
      $('.content.sitemap li').each(function () {
        if ($(this).find('ul li').length > 0) {
          $(this).addClass('expandable closed');
          $(this).find('>ul').css('max-height', '0px');
        }
      });

      $('.content.sitemap li a').click(function (e) {
        e.stopPropagation();
      });

      $('.content.sitemap li').click(function (e) {
        e.stopPropagation();
        if (!$(this).hasClass('expandable')) {
          return;
        }

        $(this).toggleClass('closed');

        var ul = $(this).find('ul').get(0);

        if ($(this).hasClass('closed')) {
          $(ul).css('max-height', ul.scrollHeight + 'px');
          setTimeout(function () {
            $(ul).css('max-height', '0px');
          }, 0);
        } else {
          $(ul).css('max-height', ul.scrollHeight + 'px');
          setTimeout(function () {
            $(ul).css('max-height', 'none');
          }, 300);
        }

      });

      $('.content.sitemap li ul').click(function (e) {
        e.stopPropagation();
      })
    }
  });
})();